import React from 'react';

const zapierReference = () => {

    const ZAPIER_URL = `${window.location.protocol}//${window.location.host}/zapier.html`;

    return (
        <div className="swagger-ui doc-page">
            <div className="information-container wrapper">
                <div className="info">
                    <h2 className="title">Zapier</h2>
                    <h2>Overview</h2>
                    <p>
                        Zapier connects Kanban Zone to 1000+ of your favorite apps so you can automate repetitive tasks without leaving Kanban Zone.
                    </p>
                    <p>
                        <a className="link" rel="noopener noreferrer" target="_self" href="https://kanbanzone.com/knowledge-base/zapier/">Learn more about Zapier...</a>
                    </p>
                </div>
                <iframe title="Zapier" frameBorder={0} src={ZAPIER_URL} />
            </div>
        </div>
    );
}

export default zapierReference;